export const EXACT = 'exact';
export const SISTER_EXACT = 'sister/exact';
export const SISTER_SIMILAR = 'sister/similar';
export const SIMILAR = 'similar';
